import Banner from './Models/Banner'

Vue.prototype.$models.$banner = new Vue(Banner)

Vue.component('banners-table', () => import(/* webpackChunkName: "banners-table" */ '@modulesPages/Banner/Resources/assets/js/Tables/BannersTable'))

Vue.component('banners-form', () => import(/* webpackChunkName: "banners-form" */ '@modulesPages/Banner/Resources/assets/js/Forms/Banners/BannersForm'))
Vue.component('default-banners-form', () => import(/* webpackChunkName: "default-banners-form" */ '@modulesPages/Banner/Resources/assets/js/Forms/Banners/DefaultBannersForm'))
Vue.component('one-image-banners-form', () => import(/* webpackChunkName: "one-image-banners-form" */ '@modulesPages/Banner/Resources/assets/js/Forms/Banners/OneImageBannersForm'))
Vue.component('just-one-image-banners-form', () => import(/* webpackChunkName: "just-one-image-banners-form" */ '@modulesPages/Banner/Resources/assets/js/Forms/Banners/JustOneImageBannersForm'))

Vue.component('banners-card', () => import(/* webpackChunkName: "banners-card" */ '@modulesPages/Banner/Resources/assets/js/Cards/BannersCard'))

Vue.component('banners-section', () => import(/* webpackChunkName: "banners-section" */ '@modulesPages/Banner/Resources/assets/js/Sections/BannersSection'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Banner\\Entities\\Banner': 'Banner',
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Banner\\Entities\\Banner': 'banners',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'banners': 'Modules\\Banner\\Entities\\Banner',
	}	
}


Vue.component('banners-card2', () => import(/* webpackChunkName: "banners-card2" */ '@modulesPages/Banner/Resources/assets/js/Cards/BannersCard2'))